var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['radio', _vm.checked ? 'checked' : 'no-checked', _vm.disabled && 'disable-checked'],on:{"click":function($event){$event.stopPropagation();return _vm.changeRadio.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }